import { useId } from "react";
import { ValueSetGet } from "../../../Editor/shapes/shapeHelper/getSetProperties";
import Select, { GroupBase, OptionProps } from "react-select";


export interface DropdownOption {
  label: string,
  value: number,
}
interface SelectInputProp<T extends DropdownOption> extends ValueSetGet<T> {
  choiseList: T[],
  properyDisplayName: string,
  disabled?: boolean,
}

const SelectInput = <O extends DropdownOption,>({ disabled, properyDisplayName, setValue, currentValue, choiseList }: SelectInputProp<O>) => {
  const inputID = useId();

  function selectionBackgroundCalculator(state: OptionProps<O, false, GroupBase<O>>) {
    if (state.isSelected) {
      return 'var(--select-color)';
    }
    if (state.isFocused) {
      return "var(--select-hover-color)";
    }
    return "inherit"
  }
  return (
    <>
      <label htmlFor={inputID} className='element__part__name'>
        {properyDisplayName}
      </label>
      <Select
        styles={{
          option: (provided, state) => ({
            ...provided,
            color: "#000000",
            backgroundColor: selectionBackgroundCalculator(state),
          })
        }}
        defaultValue={currentValue}
        isDisabled={disabled}
        options={choiseList}
        onChange={(selectedValue) => {
          console.log("slected", selectedValue);

          if (selectedValue) setValue(selectedValue); else throw new Error("no Selection");
        }}
      />
    </>
  )
}

export default SelectInput